import { createContext } from 'react';

import type { AppDataContextType } from '../interfaces/app-data.interface';

export const AppDataContext = createContext<AppDataContextType | undefined>(undefined);
